import { post } from "../http"
// 我的推荐数据汇总
export const myRecommend = params =>
  post(`/web/distribute/myRecommend`, params)
// 我的推荐-购课列表
export const buyList = params =>
  post(`/web/distribute/myRecommend/buyList`, params)
// 我的推荐-邀请列表
export const recommendList = params =>
  post(`/web/distribute/myRecommend/recommendList`, params)
// 我的分销二级邀请列表
export const getRecommendUserList = params =>
  post(`/web/distribute/getRecommendUserList`, params)
// 我的分销二级购课列表
export const getBuyUserList = params =>
  post(`/web/distribute/getBuyUserList`, params)
// 提现
export const withdrawal = params =>
  post(`/web/distribute/withdrawal/info`, params)